import { specialCharacters } from '@lon/shared/constants';
import { HandleError } from './types';

export const validatePassword = (
  password: string | undefined,
  isPreview?: boolean
) => {
  const result = [];
  if (!password?.match(/^(?!.* )/)) {
    result.push(1);
  }
  if (!password?.match(/^.{16,}$/) && !isPreview) {
    result.push(8);
  }
  if (!password?.match(/^.{10,}$/) && isPreview) {
    result.push(10);
  }
  if (!password?.match(/\d+/)) {
    result.push(3);
  }
  if (!password?.match(/[A-Z]+/)) {
    result.push(4);
  }
  if (!password?.match(/[a-z]+/)) {
    result.push(5);
  }
  if (!password?.match(specialCharacters)) {
    result.push(9);
  }
  return result;
};

export const handleError: HandleError = ({
  error,
  toast,
  username,
  t,
  i18n,
}) => {
  error?.graphQLErrors?.forEach((e: { message: string }) => {
    const [field, message] = e.message.split(': ');
    const errorMessage = `validationMessages.${field}.${message}`;

    if (i18n.exists(`${errorMessage}.title`)) {
      toast({
        title: t(`${errorMessage}.title`, { username: username }) as string,
        description: t(`${errorMessage}.description`) as string,
        isClosable: true,
        variant: 'error-light',
        duration: null,
      });
    } else {
      toast({
        title: t('validationMessages.unknown.title') as string,
        description: t('validationMessages.unknown.description') as string,
        isClosable: true,
        variant: 'error-light',
        duration: null,
      });
    }
  });
};
